import { searchUserGQL } from "@onmo/graphql/legacyGraphql";
import { useStyles } from "./SearchFriends.style";
import { PublicUser } from "@onmo/graphql/legacyGraphql";
import { FriendCard } from "../../components/common/FriendCard";
import { useMemo, useState } from "react";
import { useLegacyQuery } from "@onmo/graphql/legacyGraphql";
import { Icon } from "../../components/core/Icon/Icon";
import { TextField } from "../../components/core/TextField";
import { debounce } from "lodash";
import { Typography } from "../../components/core/Typography/Typography";
import Button from "../../components/core/Button/Button";
import { TypographyColor, TypographyVariant } from "../../constants/typography";
import { useTranslation } from "react-i18next";
import { useShareUser } from "../../hooks/resolvers/friend/friend";
import { HistoryGaming } from "../../models/historyGaming";
import { useQuery } from "@apollo/client";
import { User } from "@onmo/graphql/graphql";
import { meGQL } from "../../graphql";
import { useNavigate } from "react-router-dom";

const SearchFriends: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const [query, setQuery] = useState<string>();
  const { data, loading } = useLegacyQuery(searchUserGQL, {
    variables: { searchUsersInput: { username: query } },
    skip: !query || query?.length < 3,
  });
  const { data: dataMe } = useQuery(meGQL);
  const onInviteFriends = useShareUser();

  const debouncedOnChangeQuery = debounce((query: string) => {
    setQuery(query);
  }, 500);

  const searchResult = useMemo(() => {
    if (!data?.users?.items?.length) return data?.users?.items;

    return data?.users?.items?.filter((item: PublicUser) => {
      return item.id !== dataMe?.me?.id;
    });
  }, [data, dataMe]);

  const renderLoadingState = () => {
    return (
      <Typography variant={TypographyVariant.BodyB5Regular}
        color={TypographyColor.Silver}>
        {t("search_Searching for players")}
      </Typography>
    );
  }

  const renderEmptyState = () => {
    return (
      <>
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {query && query?.length >= 3
            ? t("search_Couldn't find") + ` “${query}”`
            : t("search_Search player by username")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB5Regular}
          color={TypographyColor.Silver}
        >
          {t(
            query && query?.length >= 3
              ? "search_Try searching again using a different spelling or keyword"
              : "search_Enter at least 3 characters to search, you can also invite your friends through social media",
          )}
        </Typography>
        {
          (!query || query?.length < 3) && (
            <Button
              size="small"
              className={classes.inviteBtn}
              onClick={onInviteFriends}
            >
              {t("common_Invite Friends")}
            </Button>
          )
        }
      </>
    )
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Icon
          name="icon-bold-arrow-left-3"
          onClick={() => HistoryGaming.back(navigate)}
          size={24}
          className={classes.icon}
        />
        <TextField
          startIcon={
            <Icon
              name="icon-linear-search-normal"
              className={classes.searchIcon}
            />
          }
          fullWidth
          inputProps={{
            placeholder: t("search_Search Player"),
          }}
          isShowClear
          onChangeValue={debouncedOnChangeQuery}
        />
      </div>
      <div className={classes.container}>
        {!searchResult?.length ? (
          <div className={classes.noResult}>
            {loading ? renderLoadingState() : renderEmptyState()}
          </div>
        ) : (
          searchResult?.map((user: PublicUser) => (
            <FriendCard
              user={
                {
                  id: user.id,
                  avatar: user.avatar,
                  xp: user.xp,
                  followStatus: user.followStatus,
                  username: user.username,
                } as User
              }
              key={user.id}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default SearchFriends;
